const FIRST_STEP = "[data-step-1]";
const TOTAL_STEPS = 24;
// const SENDFORM_URL = "http://localhost:3000/api/submitForm";
const SENDFORM_URL = "https://jrpmomentum-backend.netlify.app/.netlify/functions/submitForm";
const SENDFORM_URL_MAILER =
  "https://jrpmomentum-backend.netlify.app/.netlify/functions/sendNewApplicationMail";

let primaryGoal = "";
let firstName = "";
let lastName = "";
let howLongInterested = "";
let currentExperience = "";
let comfortableWithShoots = "";
let ableToDedicate2Hours = "";
let email = "";
let howFeelIfQualified = "";
let phone = "";
let smsConsent = false;
let whoAreYouFilling = "";
let age = "";
let childsAge = "";
let isParent = "";
let willingToTrain = "";
let whySelectYou = "";

/**
 * Shows the specified step and hides all others with animation.
 * @param {string} stepIdentifier - The identifier for the step (e.g., "1", "2", "1-error").
 */
function gotoStep(stepIdentifier) {
  const container = document.getElementById("enrollment-container");
  const progressBar = document.getElementById("progress");

  if (!container) {
    console.error(
      `Enrollment container with ID "enrollment-container" not found.`
    );
    return;
  }

  if (stepIdentifier.endsWith("error")) {
    container.style.backgroundColor = "#ECEFF1";
  } else {
    container.style.backgroundColor = "#1a1a1a";

    if (!isNaN(+stepIdentifier)) {
      progressBar.style.width = `${Math.ceil(
        (+stepIdentifier * 100) / TOTAL_STEPS
      )}%`;
    }
  }

  const allSections = container.querySelectorAll(
    ".enrollment-section, .enrollment-section-error"
  );

  const targetSelector = `[data-step-${stepIdentifier}]`;
  const targetSection = container.querySelector(targetSelector);

  allSections.forEach((section) => {
    section.classList.remove("active-step");
  });

  if (targetSection) {
    targetSection.classList.add("active-step");
  } else {
    console.warn(
      `Target section for identifier "${stepIdentifier}" (selector: "${targetSelector}") not found.`
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const firstStep = document.querySelector(
    `#enrollment-container ${FIRST_STEP}`
  );
  if (firstStep) {
    firstStep.classList.add("active-step");
  } else {
    console.warn(
      'Default first step "[data-step-1]" not found in the container.'
    );
  }

  // section 1
  let selectedGoals = [];

  const goalButtons = document.querySelectorAll("[data-goal]");
  const step1NextBtn = document.querySelector("[data-next-btn-1]");
  goalButtons.forEach((button) => {
    button.addEventListener("click", () => {
      step1NextBtn.classList.remove("hidden");
      const value = button.dataset.value;

      if (value === "Nothing") {
        selectedGoals = [];
        goalButtons.forEach((btn) => {
          btn.classList.remove("input-selected");
        });
        step1NextBtn.classList.add("hidden");
        gotoStep("1-error");
        return;
      }

      selectedGoals = selectedGoals.filter((v) => v !== "Nothing");

      if (selectedGoals.includes(value)) {
        selectedGoals = selectedGoals.filter((v) => v !== value);
        button.classList.remove("input-selected");
      } else {
        selectedGoals.push(value);
        button.classList.add("input-selected");
      }
    });
  });

  step1NextBtn.addEventListener("click", () => {
    const errMsg = document.querySelector("#section-1-error");
    errMsg.classList.add("hidden");

    if (selectedGoals.length === 0) {
      errMsg.textContent = "Please select at least one option";
      errMsg.classList.remove("hidden");
      return;
    }

    primaryGoal = selectedGoals.sort().join(",");

    if (primaryGoal === "Nothing") {
      gotoStep("1-error");
      return;
    }

    gotoStep("2");
  });

  const step1errBtn = document.querySelector("[data-next-btn-1-error]");
  step1errBtn.addEventListener("click", () => {
    gotoStep("1");
  });

  // section 2
  const step2NextBtn = document.querySelector("[data-next-btn-2");
  step2NextBtn.addEventListener("click", () => {
    gotoStep("2-5");
  });

  // section 2-5
  const step25NextBtn = document.querySelector("[data-next-btn-2-5]");
  step25NextBtn.addEventListener("click", () => {
    const firstnameInput = document.querySelector("#input-firstname");
    const lastnameInput = document.querySelector("#input-lastname");
    const nameErrorDiv = document.querySelector("#name-error");

    const enteredFirstname = firstnameInput.value.trim();
    const enteredLastname = lastnameInput.value.trim();

    if (enteredFirstname && enteredLastname) {
      if (enteredFirstname.length > 35 || enteredLastname.length > 35) {
        nameErrorDiv.textContent = "Each field should not exceed 35 characters";
        nameErrorDiv.classList.remove("hidden");
        return;
      }

      if (!nameErrorDiv.classList.contains("hidden")) {
        nameErrorDiv.classList.add("hidden");
      }

      firstName = enteredFirstname;
      lastName = enteredLastname;
      gotoStep("3");
    } else {
      nameErrorDiv.classList.remove("hidden");
    }
  });

  // section 3
  const interestedButtons = document.querySelectorAll("[data-interested]");

  interestedButtons.forEach((button) => {
    button.addEventListener("click", function () {
      interestedButtons.forEach((btn) => {
        btn.classList.remove("input-selected");
      });

      if (this.dataset.value === "Not interested") {
        gotoStep("3-error");
        return;
      }

      this.classList.add("input-selected");
      howLongInterested = this.dataset.value;
      gotoStep("4");
    });
  });

  const step3errBtn = document.querySelector("[data-next-btn-3-error]");
  step3errBtn.addEventListener("click", () => {
    gotoStep("3");
  });

  // section 4
  const step4NextBtn = document.querySelector("[data-next-btn-4]");
  step4NextBtn.addEventListener("click", () => {
    gotoStep("5");
  });

  // section 5
  const experienceButtons = document.querySelectorAll("[data-experience]");

  experienceButtons.forEach((button) => {
    button.addEventListener("click", function () {
      experienceButtons.forEach((btn) => {
        btn.classList.remove("input-selected");
      });
      this.classList.add("input-selected");
      currentExperience = this.dataset.value;

      if (currentExperience === "Advanced") {
        gotoStep("7");
        return;
      }

      gotoStep("6");
    });
  });

  // section 6
  const step6NextBtn = document.querySelector("[data-next-btn-6]");
  step6NextBtn.addEventListener("click", () => {
    gotoStep("7");
  });

  // section 7
  const comfortableButtons = document.querySelectorAll("[data-comfortable]");

  comfortableButtons.forEach((button) => {
    button.addEventListener("click", function () {
      comfortableButtons.forEach((btn) => {
        btn.classList.remove("input-selected");
      });
      this.classList.add("input-selected");
      comfortableWithShoots = this.dataset.value;

      if (comfortableWithShoots === "No") {
        gotoStep("8");
        return;
      }

      gotoStep("9");
    });
  });

  // section 8
  const step8NextBtn = document.querySelector("[data-next-btn-8]");
  step8NextBtn.addEventListener("click", () => {
    gotoStep("9");
  });

  // section 9
  const step9NextBtn = document.querySelector("[data-next-btn-9]");
  step9NextBtn.addEventListener("click", () => {
    gotoStep("10");
  });

  // section 10
  const dedicateButtons = document.querySelectorAll("[data-dedicate]");

  dedicateButtons.forEach((button) => {
    button.addEventListener("click", function () {
      dedicateButtons.forEach((btn) => {
        btn.classList.remove("input-selected");
      });
      this.classList.add("input-selected");

      if (this.dataset.value === "No") {
        this.classList.remove("input-selected");
        gotoStep("10-error");
        return;
      }

      ableToDedicate2Hours = this.dataset.value;
      gotoStep("11");
    });
  });

  const step10errBtn = document.querySelector("[data-next-btn-10-error]");
  step10errBtn.addEventListener("click", () => {
    gotoStep("10");
  });

  // section 11
  const step11NextBtn = document.querySelector("[data-next-btn-11]");
  step11NextBtn.addEventListener("click", () => {
    const emailInput = document.querySelector("#input-email");
    const emailErrorDiv = document.querySelector("#email-error");

    const enteredValue = emailInput.value.trim();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(enteredValue)) {
      if (!emailErrorDiv.classList.contains("hidden")) {
        emailErrorDiv.classList.add("hidden");
      }
      email = enteredValue;
      gotoStep("12");
    } else {
      emailErrorDiv.classList.remove("hidden");
    }
  });

  // section 12
  const step12NextBtn = document.querySelector("[data-next-btn-12]");
  step12NextBtn.addEventListener("click", () => {
    gotoStep("13");
  });

  // section 13
  const howFeelButtons = document.querySelectorAll("[data-how-feel]");

  howFeelButtons.forEach((button) => {
    button.addEventListener("click", function () {
      howFeelButtons.forEach((btn) => {
        btn.classList.remove("input-selected");
      });
      this.classList.add("input-selected");

      if (this.dataset.value === "Don't care") {
        this.classList.remove("input-selected");
        gotoStep("13-error");
        return;
      }

      howFeelIfQualified = this.dataset.value;
      gotoStep("14");
    });
  });

  const step13errBtn = document.querySelector("[data-next-btn-13-error]");
  step13errBtn.addEventListener("click", () => {
    gotoStep("13");
  });

  // section 14
  const step14NextBtn = document.querySelector("[data-next-btn-14]");
  step14NextBtn.addEventListener("click", () => {
    gotoStep("15");
  });

  // section 15 - phone
  const phoneInputField = document.querySelector("#input-phone");
  const phoneInput = window.intlTelInput(phoneInputField, {
    loadUtils: () =>
      import(
        "https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"
      ),
    formatAsYouType: true,
    formatOnDisplay: true,
    strictMode: true,
    nationalMode: true,
    initialCountry: "us",
    countryOrder: ["us", "ca", "gb", "ie"],
    separateDialCode: true,
    autoPlaceholder: "polite",
  });

  const step15SkipBtn = document.querySelector("[data-next-btn-15-skip");
  step15SkipBtn.addEventListener("click", () => {
    phone = "";
    gotoStep("15-5");
  });

  const step15NextBtn = document.querySelector("[data-next-btn-15]");
  step15NextBtn.addEventListener("click", () => {
    const errorDiv = document.querySelector("#phone-error");

    errorDiv.classList.add("hidden");
    if (phoneInput.isValidNumber()) {
      phone = phoneInput.getNumber();
      smsConsent = true;
      gotoStep("16");
    } else {
      errorDiv.textContent =
        "Please enter a valid phone number for the selected country.";
      errorDiv.classList.remove("hidden");
      phoneInputField.focus();
    }
  });

  const phoneErrorDiv = document.querySelector("#phone-error");

  phoneInputField.addEventListener("input", () =>
    phoneErrorDiv.classList.add("hidden")
  );
  phoneInputField.addEventListener("countrychange", () =>
    phoneErrorDiv.classList.add("hidden")
  );

  const step155SkipBtn = document.querySelector("[data-next-btn-15-5-skip");
  step155SkipBtn.addEventListener("click", () => {
    smsConsent = false;
    phone = false;
    gotoStep("16");
  });

  const step155NextBtn = document.querySelector("[data-next-btn-15-5");
  step155NextBtn.addEventListener("click", () => {
    if (!phone) {
      gotoStep("15");
      return;
    }

    smsConsent = true;
    gotoStep("16");
  });

  // section 16
  const whoAreYouFillingButtons = document.querySelectorAll("[data-who]");

  whoAreYouFillingButtons.forEach((button) => {
    button.addEventListener("click", function () {
      whoAreYouFillingButtons.forEach((btn) => {
        btn.classList.remove("input-selected");
      });
      this.classList.add("input-selected");

      whoAreYouFilling = this.dataset.value;

      if (whoAreYouFilling === "Myself") {
        gotoStep("17");
        return;
      }

      gotoStep("18");
    });
  });

  // section 17
  const step17NextBtn = document.querySelector("[data-next-btn-17]");
  step17NextBtn.addEventListener("click", () => {
    const ageInput = document.querySelector("#input-age");
    const ageErrorDiv = document.querySelector("#age-error");
    const enteredValue = +ageInput.value;

    if (!enteredValue) {
      if (!ageErrorDiv.classList.contains("hidden")) {
        ageErrorDiv.classList.add("hidden");
      } else {
        ageErrorDiv.classList.remove("hidden");
      }
    }

    if (enteredValue < 18) {
      window.clarity && window.clarity("event", "child_under_18");
      gotoStep("17-error");
      return;
    }

    age = ageInput.value.slice(0, 3);
    isParent = "No";
    gotoStep("19");
  });

  const step17errBtn = document.querySelector("[data-next-btn-17-error]");
  step17errBtn.addEventListener("click", () => {
    const allButtons = document.querySelectorAll(".list-option");
    allButtons.forEach((btn) => {
      btn.classList.remove("input-selected");
    });

    primaryGoal = "";
    firstName = "";
    lastName = "";
    howLongInterested = "";
    currentExperience = "";
    comfortableWithShoots = "";
    ableToDedicate2Hours = "";
    email = "";
    howFeelIfQualified = "";
    phone = "";
    whoAreYouFilling = "";
    age = "";
    isParent = "";
    willingToTrain = "";
    whySelectYou = "";
    gotoStep("1");
  });

  // section 18
  const isParentButtons = document.querySelectorAll("[data-parent]");

  isParentButtons.forEach((button) => {
    button.addEventListener("click", function () {
      isParentButtons.forEach((btn) => {
        btn.classList.remove("input-selected");
      });
      this.classList.add("input-selected");

      if (this.dataset.value === "No") {
        this.classList.remove("input-selected");
        gotoStep("18-error");
        return;
      }

      age = "under 18";
      isParent = this.dataset.value;
      gotoStep("18-5");
    });
  });

  const step185NextBtn = document.querySelector("[data-next-btn-18-5]");
  step185NextBtn.addEventListener("click", () => {
    const childsAgeInput = document.querySelector("#input-childs-age");
    const childsAgeErrorDiv = document.querySelector("#age-error");
    const enteredValue = +childsAgeInput.value;

    if (!enteredValue) {
      if (!childsAgeErrorDiv.classList.contains("hidden")) {
        childsAgeErrorDiv.classList.add("hidden");
      } else {
        childsAgeErrorDiv.classList.remove("hidden");
      }
    }

    childsAge = childsAgeInput.value.slice(0, 3);
    gotoStep("19");
  });

  // section 19
  const willingToTrainButtons = document.querySelectorAll("[data-train]");

  willingToTrainButtons.forEach((button) => {
    button.addEventListener("click", function () {
      willingToTrainButtons.forEach((btn) => {
        btn.classList.remove("input-selected");
      });
      this.classList.add("input-selected");

      if (this.dataset.value === "No") {
        this.classList.remove("input-selected");
        gotoStep("19-error");
        return;
      }

      willingToTrain = this.dataset.value;
      gotoStep("20");
    });
  });

  const step19errBtn = document.querySelector("[data-next-btn-19-error]");
  step19errBtn.addEventListener("click", () => {
    gotoStep("19");
  });

  // section 20
  const step20NextBtn = document.querySelector("[data-next-btn-20]");
  step20NextBtn.addEventListener("click", () => {
    gotoStep("21");
  });

  // section 21
  const step21NextBtn = document.querySelector("[data-next-btn-21]");
  step21NextBtn.addEventListener("click", () => {
    const errMsg = document.querySelector("#photo-error");
    errMsg.classList.add("hidden");

    if (!currentFile) {
      errMsg.classList.remove("hidden");
      return;
    }

    gotoStep("22");
  });

  const step21SkipBtn = document.querySelector("[data-next-btn-21-skip]");
  step21SkipBtn.addEventListener("click", () => {
    currentFile = false;
    gotoStep("22");
  });

  // section 22
  const step22NextBtn = document.querySelector("[data-next-btn-22]");
  step22NextBtn.addEventListener("click", () => {
    gotoStep("23");
  });

  // section 23
  let selectedReasons = [];

  const whySelectYouButtons = document.querySelectorAll(
    "[data-why-select-you]"
  );
  const step23NextBtn = document.querySelector("[data-next-btn-23]");

  whySelectYouButtons.forEach((button) => {
    button.addEventListener("click", function () {
      step23NextBtn.classList.remove("hidden");
      const value = button.dataset.value;

      if (value === "Don't pick") {
        selectedReasons = [];
        whySelectYouButtons.forEach((btn) => {
          btn.classList.remove("input-selected");
        });
        step23NextBtn.classList.add("hidden");
        gotoStep("23-error");
        return;
      }

      selectedReasons = selectedReasons.filter((v) => v !== "Don't pick");

      if (selectedReasons.includes(value)) {
        selectedReasons = selectedReasons.filter((v) => v !== value);
        button.classList.remove("input-selected");
      } else {
        selectedReasons.push(value);
        button.classList.add("input-selected");
      }
    });
  });

  step23NextBtn.addEventListener("click", async () => {
    const errMsg = document.querySelector("#section-23-error");
    errMsg.classList.add("hidden");

    if (selectedReasons.length === "0") {
      errMsg.textContent = "Please select at least one option";
      errMsg.classList.remove("hidden");
      return;
    }

    whySelectYou = selectedReasons.sort().join(",");

    const dataToSend = new FormData();
    dataToSend.append("firstName", firstName);
    dataToSend.append("lastName", lastName);
    dataToSend.append("email", email);
    dataToSend.append("phone", phone);
    dataToSend.append("age", age);
    dataToSend.append("childsAge", childsAge);
    dataToSend.append("whoAreYouFilling", whoAreYouFilling);
    dataToSend.append("isParent", isParent);
    dataToSend.append("primaryGoal", primaryGoal);
    dataToSend.append("howLongInterested", howLongInterested);
    dataToSend.append("currentExperience", currentExperience);
    dataToSend.append("comfortableWithShoots", comfortableWithShoots);
    dataToSend.append("ableToDedicate2Hours", ableToDedicate2Hours);
    dataToSend.append("howFeelIfQualified", howFeelIfQualified);
    dataToSend.append("willingToTrain", willingToTrain);
    dataToSend.append("whySelectYou", whySelectYou);
    dataToSend.append("smsConsent", smsConsent);
    dataToSend.append("campaign_20250928", "finished");

    if (currentFile && currentFile.size >= 1024) {
      dataToSend.append("image", currentFile, currentFile.name);
    } else {
      dataToSend.append("image", "false");
    }

    const spinner = document.querySelector("#enr-spinner");

    try {
      spinner.classList.remove("hidden");
      step23NextBtn.classList.add("hidden");

      const acceptsMarketing = true;
      const password = generateSecurePassword();

      function generateSecurePassword() {
        const charset =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
        let password = "";

        const array = new Uint8Array(16);
        crypto.getRandomValues(array);

        for (let i = 0; i < array.length; i++) {
          password += charset[array[i] % charset.length];
        }

        return password;
      }

      const variables = phone
        ? {
            firstName,
            lastName,
            phone,
            password,
            email,
            acceptsMarketing,
          }
        : {
            firstName,
            lastName,
            password,
            email,
            acceptsMarketing,
          };

      const mutation = phone
        ? `
        mutation customerCreate($input: CustomerCreateInput!) {
          customerCreate(input: $input) {
            customer { id email firstName lastName phone acceptsMarketing }
            customerUserErrors { field message code }
          }
        }
      `
        : `
        mutation customerCreate($input: CustomerCreateInput!) {
          customerCreate(input: $input) {
            customer { id email firstName lastName acceptsMarketing }
            customerUserErrors { field message code }
          }
        }
      `;

      await fetch("/api/2024-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "f50a6ff9731b19a4825919f4f6d52195",
        },
        body: JSON.stringify({
          query: mutation,
          variables: { input: variables },
        }),
      });

      const res = await fetch(SENDFORM_URL, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        body: dataToSend,
      });

      await fetch(SENDFORM_URL_MAILER, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        body: dataToSend,
      });

      if (res.ok) {
        try {
          window.clarity && window.clarity("event", "enrollment");
        } catch (_) {}

        if (window.gtag) {
          gtag("event", "sign_up");
          window.gtag("event", "conversion", {
            send_to: "AW-389628632/JlgzCMvhhs0aENiF5bkB",
            value: 1.0,
            currency: "USD",
          });
        }

        // Shopify.analytics.publish("sign_up");
        // localStorage.setItem("enrollment", "true");
        gotoStep("24");
        return;
      } else if (res.status == 409) {
        gotoStep("24-duplicate");
        return;
      } else {
        errMsg.textContent =
          "Something is wrong with your request. Please, restart the page and try again.";
        errMsg.classList.remove("hidden");
      }
    } catch (e) {
      errMsg.textContent =
        "Something is wrong with your internet connection. Please, restart the page and try again.";
      errMsg.classList.remove("hidden");
    } finally {
      spinner.classList.add("hidden");
      step23NextBtn.classList.remove("hidden");
    }
  });

  const step23errBtn = document.querySelector("[data-next-btn-23-error]");
  step23errBtn.addEventListener("click", () => {
    gotoStep("23");
  });

  const step24RestartBtn = document.querySelector(
    "[data-next-btn-24-duplicate]"
  );

  step24RestartBtn.addEventListener("click", () => {
    gotoStep("1");
  });
});
